import type { z } from "zod";
import { addressRequiredSchema } from "../../address";
import { organizationSchema } from "../organization.schema";

export const patchOrganizationSchema = organizationSchema.and(addressRequiredSchema);

export type PatchOrganizationSchema = z.infer<typeof patchOrganizationSchema>;
